import { OptionPartDto, OptionPartEntity } from '../interfaces';
import { Core } from '../../core';

export const OptionPartsStore = Core.Stores.create<OptionPartEntity, OptionPartDto>(
  '/parts/options',
);
